import { render } from "./NewsletterSignup.vue?vue&type=template&id=1923e8b4&scoped=true"
import script from "./NewsletterSignup.vue?vue&type=script&lang=js"
export * from "./NewsletterSignup.vue?vue&type=script&lang=js"

import "./NewsletterSignup.vue?vue&type=style&index=0&id=1923e8b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1923e8b4"]])

export default __exports__